export default "__VITE_ASSET__BrhEaWci__";